import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/service/Service";

export const adminLoginSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    adminLogin: builder.mutation({
        query: (body) => ({
          url: `Account/LoginUser`,
          method: "POST",
          body,
        }),
      }),


    })
})

export const { useAdminLoginMutation,} = apiSlice;

